var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28c0-1.937-.373-3.757-1.12-5.46a13.898 13.898 0 0 0-2.975-4.445A13.897 13.897 0 0 0 5.46 15.12C3.757 14.373 1.937 14 0 14c1.937 0 3.757-.362 5.46-1.085 1.703-.747 3.185-1.75 4.445-3.01A13.897 13.897 0 0 0 12.88 5.46C13.627 3.757 14 1.937 14 0c0 1.937.362 3.757 1.085 5.46.747 1.703 1.75 3.185 3.01 4.445 1.26 1.26 2.742 2.263 4.445 3.01C24.243 13.638 26.063 14 28 14c-1.937 0-3.757.373-5.46 1.12a13.898 13.898 0 0 0-4.445 2.975c-1.26 1.26-2.263 2.742-3.01 4.445C14.362 24.243 14 26.063 14 28Z",
    fill: "url(#google_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "google_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(18.683 -33.198 14.136) scale(29.8025 238.737)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#9168C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#5684D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1BA1E3"
  })))));
};
export default SvgGoogle;